import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import LabsApp from "./labs/App";
import { ThemeProvider, createTheme } from '@mui/material/styles';
/* Comment below to make it work with local api */
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
Amplify.configure(awsExports);
/* Comment above to make it work with local api */

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      light: "#5F9EA0",
      main: "#5F9EA0",
      dark: "#2F4F4F", 
      // contrastText: "#5F9EA0"
    }, 
    secondary: {
      light: "#5F9EA0",
      main: "#1c3623",
      dark: "#105422", 
    }
  }
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <ThemeProvider theme={theme}>
    <LabsApp />
  </ThemeProvider>
);
